import React from 'react';
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

export const FreeAutocompleteSelect = ({id, value, name, content, label, setFieldValue, setFieldTouched, touched, error, helperText, sequenceNumber, ...props}) => {
    const onChange = (e, newValue) => {
        setFieldValue(name, {...value, selectedValue: newValue})
        if (!touched && setFieldTouched) {
            setFieldTouched(name, true, false)
        }
    }

    const onInputChange = (e, newValue, reason) => {
        if (reason === 'reset') {
            if (newValue) {
                setFieldValue(name, {...value, inputValue: newValue})
                if (!touched && content?.freeSolo && setFieldTouched) {
                    setFieldTouched(name, true, false)
                }
            }
        } else {
            setFieldValue(name, {...value, inputValue: newValue})
            if (!touched && content?.freeSolo && setFieldTouched) {
                setFieldTouched(name, true, false)
            }
        }
    }

    return <Autocomplete
        id={`${id}`}
        freeSolo
        fullWidth
        clearOnEscape
        inputValue={value?.inputValue}
        onInputChange={onInputChange}
        value={value?.selectedValue}
        options={content.choices}
        getOptionLabel={(option) => option.value}
        getOptionSelected={(option, value) => option.value === value.value}
        renderInput={(params) => <TextField {...params}
                                            variant={'outlined'}
                                            size={'small'}
                                            fullWidth
                                            error={touched && Boolean(error)}
                                            helperText={error && touched ? error : helperText}
                                            label={label}/>
        }
        {...props}
        onChange={onChange}
    />
}